import compact from 'lodash/fp/compact';
import flatten from 'lodash/fp/flatten';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import uniqBy from 'lodash/fp/uniqBy';

/**
 * Extracts embedded data from paged results, flattens, removes nulls, and deduplicates.
 * @param {Array} pagedResults - Array of paged response objects
 * @param {string} embeddedPath - Path to the embedded data within each page
 * @param {string|Function} uniqueBy - Property or function used for deduplication
 * @returns {Array} Flat, unique, non-null array of extracted data
 */
export function extractPagedData(pagedResults, embeddedPath, uniqueBy) {
  return flow([map(embeddedPath), flatten, compact, uniqBy(uniqueBy)])(pagedResults);
}
